import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <div style={{
        background: '#1a56db', color: 'white',
        padding: '0 24px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <span style={{ fontSize: 20, fontWeight: 700 }}>RentOS</span>
        <a href="/" style={{
          color: 'white', fontSize: 13, opacity: 0.9,
          textDecoration: 'none'
        }}>Back to Login</a>
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '40px 24px 80px' }}>
        <h1 style={{
          fontSize: 28, fontWeight: 700, color: '#1e293b', marginBottom: 8
        }}>Privacy Policy</h1>
        <p style={{ color: '#64748b', fontSize: 14, marginBottom: 40 }}>
          Last updated: April 1, 2026
        </p>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            1. About RentOS
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8 }}>
            RentOS is a rental management platform operated by <strong>Hashvi Ventures Private Limited</strong>,
            a company registered in India. RentOS helps landlords manage their rental properties
            and communicate with tenants via WhatsApp. This Privacy Policy explains how we collect,
            use, and protect your personal information.
          </p>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginTop: 12 }}>
            For any privacy-related questions, contact us at:{' '}
            <a href="mailto:admin@rentos.co.in" style={{ color: '#1a56db' }}>admin@rentos.co.in</a>
          </p>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            2. Information We Collect
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginBottom: 12 }}>
            We collect the following information to provide our rental management services:
          </p>
          <div style={{
            background: 'white', borderRadius: 10, border: '1px solid #e2e8f0',
            overflow: 'hidden'
          }}>
            {[
              { who: 'Landlords', data: 'Name, mobile number, email address' },
              { who: 'Tenants', data: 'Name, mobile number, move-in date, security deposit amount' },
              { who: 'Properties', data: 'Building name, address, unit numbers, rent amounts' },
              { who: 'Payments', data: 'Rent amount, payment date, payment mode, UPI transaction ID' },
              { who: 'WhatsApp', data: 'Messages sent and received via WhatsApp Business API' },
            ].map((row, i) => (
              <div key={i} style={{
                display: 'flex', gap: 16, padding: '14px 20px',
                borderBottom: i < 4 ? '1px solid #f1f5f9' : 'none',
                background: i % 2 === 0 ? 'white' : '#f8fafc'
              }}>
                <div style={{ minWidth: 120, fontWeight: 500, fontSize: 14, color: '#374151' }}>
                  {row.who}
                </div>
                <div style={{ fontSize: 14, color: '#64748b' }}>{row.data}</div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            3. How We Use Your Information
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginBottom: 12 }}>
            We use your information solely to provide the RentOS rental management service:
          </p>
          <ul style={{ paddingLeft: 20, color: '#374151', fontSize: 15, lineHeight: 2 }}>
            <li>To authenticate landlords via WhatsApp OTP login</li>
            <li>To send rent payment reminders to tenants via WhatsApp</li>
            <li>To generate and deliver rent receipts to tenants via WhatsApp</li>
            <li>To notify landlords of incoming rent payments</li>
            <li>To maintain payment history and generate receipts for HRA purposes</li>
            <li>To send move-in welcome messages and move-out confirmations to tenants</li>
          </ul>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginTop: 12 }}>
            We do <strong>not</strong> use your data for marketing, advertising, or any purpose
            other than providing the RentOS service.
          </p>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            4. WhatsApp Messaging
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8 }}>
            RentOS uses the WhatsApp Business API (provided by Meta Platforms, Inc.) to send
            messages to landlords and tenants. By using RentOS, you consent to receiving
            WhatsApp messages from our business number (+91 93803 18018) for the purposes
            described above. Standard WhatsApp data processing terms apply as per{' '}
            <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank"
              rel="noreferrer" style={{ color: '#1a56db' }}>
              WhatsApp's Privacy Policy
            </a>.
          </p>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            5. Data Retention
          </h2>
          <ul style={{ paddingLeft: 20, color: '#374151', fontSize: 15, lineHeight: 2 }}>
            <li>Active tenant records are retained while the tenancy is active</li>
            <li>After a tenant moves out, their records are retained for 90 days and then archived</li>
            <li>Payment records and receipts are retained indefinitely for accounting purposes</li>
            <li>Landlord accounts are retained until the account is deleted upon request</li>
          </ul>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            6. Data Sharing
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8 }}>
            We do not sell, rent, or share your personal data with third parties except:
          </p>
          <ul style={{ paddingLeft: 20, color: '#374151', fontSize: 15, lineHeight: 2 }}>
            <li><strong>Meta (WhatsApp)</strong> — to deliver WhatsApp messages</li>
            <li><strong>Railway</strong> — our cloud hosting provider where data is stored securely</li>
            <li><strong>As required by law</strong> — if compelled by Indian law or court order</li>
          </ul>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            7. Data Security
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8 }}>
            We implement appropriate technical measures to protect your data including HTTPS
            encryption for all data in transit, secure PostgreSQL database with restricted
            access, and JWT-based authentication with OTP verification. No method of
            transmission over the internet is 100% secure, but we take reasonable precautions
            to protect your information.
          </p>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            8. Your Rights
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginBottom: 12 }}>
            You have the right to:
          </p>
          <ul style={{ paddingLeft: 20, color: '#374151', fontSize: 15, lineHeight: 2 }}>
            <li>Request access to your personal data held by RentOS</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and associated data</li>
            <li>Withdraw consent for WhatsApp messaging</li>
          </ul>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8, marginTop: 12 }}>
            To exercise any of these rights, contact us at{' '}
            <a href="mailto:admin@rentos.co.in" style={{ color: '#1a56db' }}>admin@rentos.co.in</a>.
          </p>
        </section>

        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            9. Changes to This Policy
          </h2>
          <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.8 }}>
            We may update this Privacy Policy from time to time. We will notify landlords of
            significant changes via WhatsApp or email. Continued use of RentOS after changes
            constitutes acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
            10. Contact Us
          </h2>
          <div style={{
            background: 'white', borderRadius: 10,
            border: '1px solid #e2e8f0', padding: '20px 24px'
          }}>
            <p style={{ fontWeight: 600, color: '#1e293b', marginBottom: 8 }}>
              Hashvi Ventures Private Limited
            </p>
            <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.8 }}>
              Email: <a href="mailto:admin@rentos.co.in" style={{ color: '#1a56db' }}>admin@rentos.co.in</a><br />
              WhatsApp: +91 93803 18018<br />
              Website: <a href="https://rentos.co.in" style={{ color: '#1a56db' }}>https://rentos.co.in</a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
